import { AuthenicateRepository } from './authenicate';
import { BundleOptionRepository } from './bundleoption';
import { ContractRepository } from './contract';
import { CustomerRepository } from './customer';
import { PayinfoRepository } from './payinfo';
import { UserinfoRepository } from './userinfo';
import { HatenohamaRepository } from './hatneohama';
import { MnpRepository } from './mnp';
import { SimExchangeDeliveryRepository } from './simexchangedelivery';
import { DataChargeRepository } from './datacharge';
import { BundleOptionHikari01InheritedRepository } from './bundleoptionhikari01inherited';
import { SubContractHikari01TelRepository } from './subcontracthikari01tel';
import { InvitationUmobiledRepository } from './invitationumobiled';
export const AUTHENICATE = Symbol('authenicate');
export const BUNDLE_OPTION = Symbol('bundle_option');
export const CONTRACT = Symbol('contract');
export const CUSTOMER = Symbol('customer');
export const HATENOHAMA = Symbol('hatenohama');
export const PAYINFO = Symbol('payinfo');
export const USERINFO = Symbol('userinfo');
export const MNP = Symbol('mnp');
export const SIM_EXCHANGE_DELIVERY = Symbol('sim_exchange_delivery');
export const DATA_CHARGE = Symbol('data_charge');
export const BUNDLE_OPTION_HIKARI01_INHERITED = Symbol('bundle_option_hikari01_inherited');
export const SUB_CONTRACT_HIKARI01_TEL = Symbol('sub_contract_hikari01_tel');
export const INVITATION_UMOBILED = Symbol('invitation_umobiled');
export default {
    [AUTHENICATE]: new AuthenicateRepository(),
    [BUNDLE_OPTION]: new BundleOptionRepository(),
    [CONTRACT]: new ContractRepository(),
    [CUSTOMER]: new CustomerRepository(),
    [HATENOHAMA]: new HatenohamaRepository(),
    [PAYINFO]: new PayinfoRepository(),
    [USERINFO]: new UserinfoRepository(),
    [MNP]: new MnpRepository(),
    [SIM_EXCHANGE_DELIVERY]: new SimExchangeDeliveryRepository(),
    [DATA_CHARGE]: new DataChargeRepository(),
    [BUNDLE_OPTION_HIKARI01_INHERITED]: new BundleOptionHikari01InheritedRepository(),
    [SUB_CONTRACT_HIKARI01_TEL]: new SubContractHikari01TelRepository(),
    [INVITATION_UMOBILED]: new InvitationUmobiledRepository()
};
